import Api from "@/services/api";
import {
    LOAD_HOSTS,
    CREATE_HOST,
    EDIT_HOST,
    REMOVE_HOST,
    REMOVE_HOSTS,
    ADD_ALERT,
} from "@/store/_actiontypes";
import {
    SET_HOST,
    ADD_HOST,
    UPDATE_HOST,
    DELETE_HOST,
} from "@/store/_mutationtypes";

const state = {
    hostlist: [],
};

const actions = {
    [LOAD_HOSTS]({ commit }) {
        Api.get("/host").then((response) => {
            let vHosts = response.data;
            commit(SET_HOST, vHosts);
        });
    },
    [CREATE_HOST]({ commit, dispatch }, { host }) {
        return Api.post("/host", {
            name: host.name,
            protocolId: host.protocolId,
            protocolName: host.protocolName,
            protocolType: host.protocolType,
            port: host.port,
            deley: host.deley,
            sendENQ: host.sendENQ,
            useTls: host.useTls,
            pfxFile: host.pfxFile,
            pfxPass: host.pfxPass,
            isRunning: host.isRunning,
            hostStatus: host.hostStatus,
            reqCount: host.reqCount,
            useTpdu: host.useTpdu,
            nii: host.nii,
            useLen: host.useLen,
            useStx: host.useStx,
            useVisa1: host.useVisa1,
            isActive: host.isActive,
        }).then((response) => {
            let vHosts = response.data;
            commit(ADD_HOST, vHosts);
            dispatch(
                `alert/${ADD_ALERT}`,
                { message: "Host added successfully", color: "success" },
                { root: true }
            );
        });
    },
    [EDIT_HOST]({ commit, dispatch }, { host }) {
        return Api.put(`/host/${host.id}`, host).then((response) => {
            let vHosts = response.data;
            commit(UPDATE_HOST, vHosts);
            dispatch(
                `alert/${ADD_ALERT}`,
                { message: "Host updated successfully", color: "success" },
                { root: true }
            );
        });
    },
    [REMOVE_HOST]({ commit, dispatch }, { id }) {
        Api.delete(`/host/${id}`).then(() => {
            commit(DELETE_HOST, id);
            dispatch(
                `alert/${ADD_ALERT}`,
                { message: "Host deleted successfully", color: "success" },
                { root: true }
            );
        });
    },
    [REMOVE_HOSTS]({ commit, dispatch }, { ids }) {
        ids.forEach((id) => {
            Api.delete(`/host/${id}`).then(() => {
                commit(DELETE_HOST, id);
            });
        });
        dispatch(
            `alert/${ADD_ALERT}`,
            {
                message: `Successfully deleted ${ids.length} hosts`,
                color: "success",
            },
            { root: true }
        );
    },
};

const mutations = {
    [SET_HOST](state, hosts) {
        state.hostlist = hosts;
    },
    [ADD_HOST](state, hosts) {
        state.hostlist.push(hosts);
    },
    [UPDATE_HOST](state, host) {
        let hostUpdated = state.hostlist.find((h) => h.id == host.id);
        hostUpdated.name = host.name;
        hostUpdated.protocolId = host.protocolId;
        hostUpdated.protocolName = host.protocolName;
        hostUpdated.protocolType = host.protocolType;
        hostUpdated.port = host.port;
        hostUpdated.deley = host.deley;
        hostUpdated.sendENQ = host.sendENQ;
        hostUpdated.nii = host.nii;
        hostUpdated.useTls = host.useTls;
        hostUpdated.pfxFile = host.pfxFile;
        hostUpdated.pfxPass = host.pfxPass;
        hostUpdated.isRunning = host.isRunning;
        hostUpdated.reqCount = host.reqCount;
        hostUpdated.hostStatus = host.hostStatus;
        hostUpdated.useTpdu = host.useTpdu;
        hostUpdated.useLen = host.useLen;
        hostUpdated.useStx = host.useStx;
        hostUpdated.useVisa1 = host.useVisa1;
        hostUpdated.isActive = host.isActive;
    },
    [DELETE_HOST](state, id) {
        state.hostlist = state.hostlist.filter((h) => h.id != id);
    },
};

export const hosts = {
    namespaced: true,
    state,
    actions,
    mutations,
};